const AI_HOSTS = new Set(["thedoar.ai", "www.thedoar.ai", "localhost-ai"]);
const GATEWAY_HOSTS = new Set(["todoar.co", "www.todoar.co", "localhost-gateway"]);
const SPACE_HOSTS = new Set(["doarspace.com", "www.doarspace.com", "localhost-space"]);
const MARKETPLACE_HOSTS = new Set(["thedoar.com", "www.thedoar.com", "localhost-marketplace"]);

const SUPERSEDED_PRODUCT_ROUTES = new Map([
  ["/home", "/"],
  ["/my-realities", "/space"],
]);

export function isDoarAiHostname(hostname = "") {
  return AI_HOSTS.has(String(hostname).toLowerCase());
}
export function isGatewayHostname(hostname = "") {
  return GATEWAY_HOSTS.has(String(hostname).toLowerCase());
}
export function isSpaceHostname(hostname = "") {
  return SPACE_HOSTS.has(String(hostname).toLowerCase());
}
export function isMarketplaceHostname(hostname = "") {
  return MARKETPLACE_HOSTS.has(String(hostname).toLowerCase());
}

// `/d/:doarId` is the canonical object-centric editor entry. `/space/*` is
// retained as the project/workspace compatibility surface during migration.
export function isSpacePath(pathname = "") {
  return pathname === "/space" || pathname.startsWith("/space/") || pathname.startsWith("/space-v2/") || pathname.startsWith("/d/");
}

export function isLegacyAppPath(pathname = "") {
  return pathname === "/app" || pathname.startsWith("/app/");
}

export function legacyAppToSpace(pathname = "") {
  if (!isLegacyAppPath(pathname)) return pathname;
  return `/space${pathname.slice(4)}`;
}

export function isLegacyAiPath(pathname = "") {
  return pathname === "/ai" || pathname.startsWith("/ai/");
}

export function getSupersededProductDestination(pathname = "") {
  return SUPERSEDED_PRODUCT_ROUTES.get(pathname) || null;
}

export function isAuthUtilityPath(pathname = "") {
  return ["/login", "/register", "/reset-password", "/verify-email"].includes(pathname);
}
